export default __webpack_public_path__ + "static/ls-4da2b95cae76b6c755c221abd9eddcf2.svg";